import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchCompanies } from "../../slices/apps/companySlice";

// sayfalar, modallar vs.
import CompanyTable from "./CompanyTable";

const Companies = () => {
  document.title = "Firmalar | Metiner Avantaj+";

  const dispatch = useDispatch();

  // states
  const [loading, setLoading] = useState(true);

  const { companiesRefresh } = useSelector((state) => {
    return {
      companiesRefresh: state.company.companiesRefresh,
    };
  }, shallowEqual);

  const fetchData = async () => {
    setLoading(true);

    try {
      await dispatch(fetchCompanies());
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, companiesRefresh]);

  if (loading) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "50vh" }}
            >
              <Spinner color="primary">Yükleniyor...</Spinner>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs={12}>
              <CompanyTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Companies;
